import { t } from "@/i18n";
import { HrEmployeeStatus } from "@/types/hr/Hr";

export function hrEmployeeStatusLabel(status: HrEmployeeStatus): string {
  const keys: Record<HrEmployeeStatus, string> = {
    ACTIVE: "hr.statusActive",
    DISMISSED: "hr.statusDismissed",
    ARCHIVED: "hr.statusArchived",
    SERVICE: "hr.statusService",
  };
  return t(keys[status]) || status;
}
